import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/core/services/jwt.service";
import { LOGOUT } from "@/core/services/store/auth.module";
import router from "./../../router";

/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
  init(store) {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = "https://apifacturacionbot.contemporaseguros.com";
    // Para correcion futura
    // Vue.axios.defaults.baseURL = "https://apifacturacionbot.contemporaseguros.com/facturacioncomisionapi";
    // Dev
    // Vue.axios.defaults.baseURL = "https://localhost:44340";
    Vue.axios.interceptors.response.use(
      response => {
        return response;
      }, async (err) => {
        if (err.response.status === 401) {
          store.dispatch(LOGOUT);
          router.push({ name: "login" });
        }
        if (err.response.status === 400) {
          throw err.response.data;
        }
        return (err);
      });

  },

  /**
   * Set the default HTTP request headers
   */
  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getToken()}`;
  },

  setToken(token) {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${token}`;
  },

  query(resource, params) {
    //Vue.axios.defaults.baseURL = resource.baseURL;
    return Vue.axios.get(resource.action, params).catch((error) => {
      // //console.log((error);
      throw error; //new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  get(resource, slug = "") {
    //Vue.axios.defaults.baseURL = resource.baseURL;
    return Vue.axios.get(`${resource.action}/${slug}`).catch((error) => {
      throw error;
    });
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  getNew(resource) {
    //Vue.axios.defaults.baseURL = resource.baseURL;
    return Vue.axios.get(`${resource.action}`).catch((error) => {
      throw error;
    });
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params) {
    //Vue.axios.defaults.baseURL = resource.baseURL;
    return Vue.axios.post(`${resource.action}`, params).catch((error) => {
      throw error;
    });
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params) {
    //Vue.axios.defaults.baseURL = resource.baseURL;
    return Vue.axios.put(`${resource.action}/${slug}`, params).catch((error) => {
      throw error;
    });
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params) {
    //Vue.axios.defaults.baseURL = resource.baseURL;
    return Vue.axios.put(`${resource.action}`, params).catch((error) => {
      throw error;
    });
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  patch(resource, slug, params) {
    //Vue.axios.defaults.baseURL = resource.baseURL;
    return Vue.axios.patch(`${resource.action}/${slug}`, params).catch((error) => {
      throw error;
    });
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource) {
    //Vue.axios.defaults.baseURL = resource.baseURL;
    return Vue.axios.delete(resource.action).catch((error) => {
      throw error;
    });
  },
};

export default ApiService;
